<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Treaty Detail
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <form data-vv-scope="queryTreatyDetFilterForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs6>
                            <v-text-field
                              data-vv-scope="queryTreatyDetFilterForm"
                              v-model="filtersTreatyDet.ttyNo"
                              :label="filtersTreatyDetLabel.ttyNo"
                              :error-messages="errors.collect('ttyNo')"
                              data-vv-name="ttyNo"
                              :data-vv-as="filtersTreatyDetLabel.ttyNo"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 xs6>
                            <v-text-field
                              data-vv-scope="queryTreatyDetFilterForm"
                              v-model="filtersTreatyDet.ttyName"
                              :label="filtersTreatyDetLabel.ttyName"
                              :error-messages="errors.collect('ttyName')"
                              data-vv-name="ttyName"
                              :data-vv-as="filtersTreatyDetLabel.ttyName"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearTreatyDetFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="doTreatyDetFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <v-data-table
            :headers="treatyDetHeaders"
            :items="treatyDetItems"
            v-bind:options.sync="paginationTreatyDet"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :server-items-length="totalItemsTreatyDet"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td>{{ row.item.riType }}</td>
                <td>{{ row.item.ttyNo }}</td>
                <td>{{ row.item.ttyName }}</td>
                <td>{{ row.item.uwYr }}</td>
                <td>{{ row.item.cedBrk }}</td>
                <td>{{ row.item.cedCo }}</td>
                <td style="text-align: center">
                  <v-btn text icon color="primary" type="submit" @click.prevent="assignTreatyDet(row.item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </tr></template
            >
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersTreatyDetLabel: {
        ttyNo: 'Treaty No.',
        ttyName: 'Name'
      },
      filtersTreatyDet: {
        ttyNo: undefined,
        ttyName: undefined
      },
      treatyDetItems: [],
      totalItemsTreatyDet: 0,
      treatyDetHeaders: [
        { text: 'RI Type', align: 'left', value: 'riType' },
        { text: 'Treaty No.', value: 'ttyNo' },
        { text: 'Treaty Name', value: 'ttyName' },
        { text: 'Uw Year', value: 'uwYr' },
        { text: 'Cedant Broker', value: 'cedBrk' },
        { text: 'Cedant Company', value: 'cedCo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationTreatyDet: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearTreatyDetFilters()
      }
    },
    'paginationTreatyDet': function (value) {
      this.fetchTreatyDetData()
    }
  },
  mounted() {
    this.doClearTreatyDetFilters()
  },
  methods: {
    closeDialog() {
      this.resetFilterForm()
      this.$emit('close')
    },
    doClearTreatyDetFilters() {
      this.resetFilterForm()
      this.fetchTreatyDetData()
    },
    doTreatyDetFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryTreatyDetFilterForm').then((result) => {
        if (result) {
          this.paginationTreatyDet.page = 1
          this.fetchTreatyDetData()
        }
      })
    },
    async fetchTreatyDetData() {
      const apiUrl = this.$store.state.treatyAcct.treatyMaster.menu.getTreatyDetListByRIType
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationTreatyDet
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            riType: 'O',
            cedBrk: this.ttyHeaderForm.cedBrk,
            cedCo: this.ttyHeaderForm.cedCo
          }
          let messageFilters = clone(this.filtersTreatyDet)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), messageFilters, this.paginationTreatyDet.sortBy, this.paginationTreatyDet.sortDesc)
          )
          if (result.data) {
            this.totalItemsTreatyDet = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'treatyDetItems', data)
            } else {
              this.$set(this, 'treatyDetItems', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignTreatyDet(data) {
      // Use $emit to call parent Accounts page method assignTreatyDet and pass the value
      this.$emit('assign-ttyRef', data)
      // this.$emit('assign-acct-no', data.inter)
      this.$emit('close')
    },
    resetFilterForm() {
      this.filtersTreatyDet.ttyNo = ''
      this.filtersTreatyDet.ttyName = ''
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    ttyHeaderForm: {
      type: Object,
      default: null
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
